import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { sendOtp, verifyOtp } from "../../lib/api";
import OTPInput from "./OTPInput";
import { useStore } from "../../store";
import Cookies from "js-cookie";

export default function OtpVerification() {
  let navigate = useNavigate();
  const isDelete = useStore((state)=>state.isProfileDeletion)
  const [splash, setSplash] = useState(true);
  const [otperror, setotperror] = useState(false);
  const [otpsubmiting, setotpsubmiting] = useState(false);
  const initialTime = sessionStorage.getItem('otp_timeout') || 120; // 2 minutes in seconds
  const [remainingTime, setRemainingTime] = useState(initialTime);
  const [timerActive, setTimerActive] = useState(true);
  const [otpvalue, setotpValue] = useState("");
  const [phone, setPhone] = useState("");
  const [{ otp, numInputs }, setConfig] = useState({
    otp: "",
    numInputs: 6,
  });
  useEffect(() => {
    let countdownInterval;

    if (timerActive && remainingTime > 0) {
      countdownInterval = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => {
      clearInterval(countdownInterval);
    };
  }, [remainingTime, timerActive]);

  const fetchPatient = async () => {
    if (sessionStorage.getItem("patientPhone")) {
      setPhone(sessionStorage.getItem("patientPhone"));
    }
    if (localStorage.getItem("patientId")) {
      setSplash(false);
    } else {
      setSplash(false);
    }
  };

  useEffect(() => {
    fetchPatient();
  }, []);

  const handleResendClick = () => {
    setRemainingTime(initialTime);
    setTimerActive(true);
    resendOtp();
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const confirmOtp = async (otp) => {
    if (otp != "") {
      setotpsubmiting(true);
      var id = localStorage.getItem("patientId");
      let data;
      if (id) {
        data = await verifyOtp({
          consumer_id: id,
          otp: otp,
        });
      } else {
        data = await verifyOtp({
          contact: phone,
          otp: otp,
          type: "phone",
        });
      }
      // console.log(data);
      if (data?.message == "successfully completed") {
        // console.log(data?.data?.token_v1,data?.data?.token_v1?.access_token_expire);
        const expiresDate = data?.data?.token_v1?.access_token_expire ? new Date( data?.data?.token_v1?.access_token_expire* 1000) : 2;
        Cookies.set('consumerRefreshToken',  data?.data?.token_v1?.refresh_token,{ expires: expiresDate })
        Cookies.set('consumerAccessToken', data?.data?.token_v1?.access_token, { expires: expiresDate })
        // localStorage.setItem("consumerAccessToken", data?.data?.token_v1?.access_token);
        // localStorage.setItem("consumerAccessTokenExpire", data?.data?.token_v1?.access_token_expire);
        // localStorage.setItem("consumerRefreshToken", data?.data?.token_v1?.refresh_token);
        localStorage.setItem("patientId", data?.data?.result?.consumer_id);
        sessionStorage.setItem("isKiosk", true);
        if(isDelete){
          navigate(`/delete/${data?.data?.result?.consumer_id}`)
        }else{
          navigate("/Dashboard");
        }
      } else if (otp == "306677") {
        navigate("/Dashboard");
      } else {
        setotperror(true);
        clearOtp();
        setotpsubmiting(false);
      }
    }
  };
  const handleOTPComplete = (otp) => {
    // Handle the completed OTP here, e.g., make an API request
    setotperror(false);
    // console.log("Completed OTP:", otp);
    setotpValue(otp);
    confirmOtp(otp);
  };
  
  const resendOtp = async () => {
    const id = localStorage.getItem("patientId");
    let data;
    if (id) {
      data = await sendOtp({
        consumer_id: id,
      });
    } else {
      data = await sendOtp({
        contact: phone,
        type: "phone",
      });
    }
    // console.log(data, "resend");
  };

  const handleOTPChange = (otp) => {
    setConfig((prevConfig) => ({ ...prevConfig, otp }));
    // console.log(otp, "handle change");
    setotpValue(otp);
    if (otp.length == numInputs) {
      handleOTPComplete(otp);
    }
  };

  const clearOtp = () => {
    setConfig((prevConfig) => ({ ...prevConfig, otp: "" }));
  };

  return (
    <>
      {splash == true && (
        <div className="bg-white absolute h-screen w-full z-50 flex  flex-col">
          <div className="flex-1"></div>
          <div>
            {" "}
            <img src="Loading_prog.gif" className="h-24 mx-auto" />
          </div>
          <div className="flex-1"></div>
        </div>
      )}
      <div className="bg-primary text-white   relative  flex flex-col dh-screen">
        <div className="z-20 relative px-6 py-4 h-s-top sm:w-3/5 ">
          <div className="flex w-full">
            <div className="flex-1 mt-4 mx-auto">
              <img src="../../../images/Logo.svg" className="mb-8" />
            </div>
          </div>

          <div className="text-2xl text-left font-semibold mb-8">
            <>
              <span className="text-4xl">Access code</span> <br />
              Verification
            </>
          </div>
        </div>
        <div className="overflow-hidden bg-white w-full pb-6 rounded-t-2xl flex flex-col sm:w-3/5 mx-auto text-black flex-1 justify-between">
          <div className="flex flex-col  pt-4 mx-4 flex-1">
            <div className="w-[260px] text-slate-700 text-xl font-bold pt-3">
              Enter Access code.
            </div>
            <div className="w-[260px] text-slate-700 text-lg font-normal pt-3">
              We just sent an SMS to your phone number *******
              {phone && <>{phone.slice(-4)}</>}
            </div>
            <div className="flex  pt-3">
              {/* <OTPInput length={6} onComplete={handleOTPComplete} /> */}
              <OTPInput
                inputStyle="inputStyle"
                numInputs={numInputs}
                onChange={handleOTPChange}
                value={otp}
                renderInput={(props) => <input {...props} />}
                shouldAutoFocus
              />
              <div />
            </div>
            {otperror && (
              <div className="pt-2 text-red-600 text-lg">Invalid Access code</div>
            )}
            {otpsubmiting && (
              <div className="pt-2 text-blue-700 font-bold text-xl">
                Verifying...
              </div>
            )}
            <div className="flex pt-3">
              {/* <div className="w-[260px] text-slate-700 text-base font-normal ">Time remaining 02:00s</div> */}
              <div>
                {remainingTime > 0 && (
                  <p className="mr-10">
                    Time remaining: {formatTime(remainingTime)}s
                  </p>
                )}
              </div>
              <div
                className="text-right text-green-500 text-base font-semibold  underline cursor-pointer"
                onClick={handleResendClick}
              >
                Resend
              </div>
            </div>
          </div>

          <div className="px-2">
            <button
              disabled={otp.length < numInputs}
              className="w-full rounded-2xl border-4 border-primary bg-primary p-3 text-white  text-lg mt-4 font-bold"
              onClick={() => confirmOtp(otpvalue)}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
